module.exports = __webpack_public_path__ + "img/uk-real-estate-hotel.bdccb4e7.jpg";